import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {BREADCRUMBS_DEVICE_OPERATIONAL_STATISTIC} from "./constants/breadcrumbs";
import {
    DeviceOperationalStatisticLazy
} from "@containers/device/containers/deviceOperationalStatistic/DeviceOperationalStatistic.lazy";


const DeviceOperationalStatisticPage = () => {
    return (
        <PageLayout
            breadcrumbs={BREADCRUMBS_DEVICE_OPERATIONAL_STATISTIC}
        >
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <DeviceOperationalStatisticLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default DeviceOperationalStatisticPage;